import { sectionRoutes } from '../helpers';

export const ENTITY_CONFIGURATION_ROUTES = sectionRoutes({
  meta: { adminTab: 'Entity Management' },
  tabKey: 'entityConfigurationTab',
  routes: [
    ['entity-management/configuration', 'AdminEntityConfigurationTypes', 'configuration'],
    ['entity-management/creator', 'AdminEntityConfigurationCreator', 'creator'],
    ['entity-management/user-entity-links', 'AdminEntityConfigurationUserEntityLinks', 'user-entity-links'],
    ['entity-management/relationships', 'AdminEntityConfigurationRelationships', 'relationships'],
    ['entity-management/classification', 'AdminEntityConfigurationClassification', 'classification'],
    ['entity-management/scorecard-metrics', 'AdminEntityConfigurationScorecardMetrics', 'scorecard-metrics'],
  ],
});
